export default {
    photo: 'photo',
    contacts: 'contacts',
    meeting: 'meeting'
}
